import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const ImageContainer = styled.div`
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: space-around;
`

export const Container = styled.div`
  height: 100vh;
`
